import { useCallback } from 'react';
import { useNotifier } from '@provider/notifier';
import { useTrackingManager } from '@provider/tracking';
import { IconButton } from '@ui/kit';
import { EyeIcon } from '@ui/kit/icons';
import { makePreviewLightboxConfig } from '../../modals/preview-lightbox.js';
import { jsx, Fragment } from 'react/jsx-runtime';

function OpenAction(props) {
  const notifier = useNotifier();
  const tracker = useTrackingManager();
  const handleClick = useCallback(evt => {
    evt.stopPropagation();
    props.onClick?.();
    tracker.trackEvent("userarea-delinger.builder.userarea.clickedCourse");
    notifier.modal(makePreviewLightboxConfig({
      course: props.course
    }));
  }, [notifier, props, tracker]);
  return /*#__PURE__*/jsx(Fragment, {
    children: /*#__PURE__*/jsx(IconButton, {
      icon: /*#__PURE__*/jsx(EyeIcon, {}),
      label: "Se forl\xF8b",
      onClick: handleClick
    })
  });
}

export { OpenAction };
//# sourceMappingURL=actions.open.js.map
